
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";



const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 420,
  bgcolor: "#f7f7f7",
  borderRadius: "16px",
  boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
  p: "24px",
};


/**
 * Componente de modal que mantem a referencia ao componente
 * mesmo quando o pai muda. Isso evita que o componente
 * seja re-renderizado quando o pai muda, o que pode causar
 * problemas de performance.
 *
 * @param {boolean} open - Se o modal esta aberto ou fechado.
 * @param {function} handleClose - Função para fechar o modal.
 * @param {function} onResult - Função que recebe o resultado da
 * acao do usuario (true para confirmar, false para cancelar).
 * @returns {JSX.Element} - O componente de modal.
 */
export default function YesOrNot({ open, handleClose, onResult }) {
  /**
   * Função chamada quando o usuário confirma a ação.
   * Retorna 'true' e fecha o modal.
   */
  const handleConfirmClick = () => {
    onResult(true); // Retorna 'true'
    handleClose(); // Fecha o modal
  };

  const handleCancelClick = () => {
    onResult(false); // Retorna 'false'
    handleClose(); // Fecha o modal
  };

  return (
    <Modal
      keepMounted
      open={open}
      onClose={handleCancelClick}
      aria-labelledby="keep-mounted-modal-title"
      aria-describedby="keep-mounted-modal-description"
    >
      <Box sx={style}>

        {/* HEADER */}
        <Stack direction="row" alignItems="center" spacing={1}>
          <IconButton onClick={handleCancelClick} sx={{ p: 0 }}>
            <CloseIcon sx={{ color: "#012442" }} />
          </IconButton>

          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: "#012442",
              flexGrow: 1,
              textAlign: "center",
              mr: "40px" // compensa o botão da esquerda pra centralizar visualmente
            }}
          >
            Confirmar ação
          </Typography>
        </Stack>

        <Divider sx={{ my: 2 }} />

        {/* BODY */}
        <Typography
          sx={{
            color: "#012442",
            fontSize: "15px",
            lineHeight: 1.6,
            mb: 3,
          }}
        >
          Você tem certeza que deseja continuar com esta etapa?
          Essa ação poderá impactar o andamento do processo.
        </Typography>

        {/* FOOTER ACTIONS */}
        <Stack spacing={1.5}>

          {/* BOTÃO PRINCIPAL (SIM) */}
          <Button
            fullWidth
            variant="contained"
            onClick={handleConfirmClick}
            sx={{
              backgroundColor: "#ff0000",
              borderRadius: "12px",
              py: 1.4,
              fontWeight: 600,
              textTransform: "none",
              fontSize: "15px",
              "&:hover": {
                backgroundColor: "#cc0000",
              },
            }}
          >
            Sim, continuar
          </Button>

          {/* BOTÃO SECUNDÁRIO (NÃO) */}
          <Button
            onClick={handleCancelClick}
            sx={{
              color: "#012442",
              textTransform: "none",
              fontWeight: 500,
              fontSize: "14px",
              textDecoration: "underline",
              "&:hover": {
                backgroundColor: "transparent",
                textDecoration: "underline",
              },
            }}
          >
            Não, cancelar
          </Button>

        </Stack>
      </Box>

    </Modal>
  );
}
